import { createFileRoute } from '@tanstack/react-router';
import { OrderDetailPage } from 'src/pages/billing/order-detail';
import { DashboardLayout } from 'src/layouts/dashboard/layout';
import { AuthGuard } from '@onesource/components';

export const Route = createFileRoute('/orders/$orderNo')({
  component: () => (
    <DashboardLayout>
      <AuthGuard>
        <OrderDetailPage />
      </AuthGuard>
    </DashboardLayout>
  ),
});
